import { useCallback } from "react";
import type { Person } from "@b2bportal/air-booking-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { SeatInfo } from "@hopper-b2b/types";
import clsx from "clsx";
import type { SelectedSeatSegment } from "../SelectedSeats";

import styles from "./styles.module.scss";

const SelectedSeat = ({ pax, seat }: { pax?: string; seat?: SeatInfo }) => {
  const { t } = useI18nContext();
  return (
    <div className={styles.SelectedSeat}>
      <span className="name">{pax}</span>
      <span className={clsx("number", { selected: !seat?.seat_id })}>
        {seat?.seat_id ? seat.seat_id : t("seatNotSelected")}
      </span>
    </div>
  );
};

export const SeatSelections = ({
  passengers,
  selectedSeatSegments,
  originCode,
  destinationCode,
}: {
  passengers?: Person[];
  selectedSeatSegments?: SelectedSeatSegment[];
  originCode?: string;
  destinationCode?: string;
}) => {
  const getPaxName = (person: Person) => {
    return [person.givenName, person.surname].join(" ").replace(/\s+/g, " ");
  };

  const getSeatSegment = useCallback(
    (passenger: Person, originCode: string, destinationCode: string) => {
      const selSeg = selectedSeatSegments.find((seg) => {
        return (
          seg.originCode === originCode &&
          seg.destinationCode === destinationCode
        );
      });

      return selSeg?.seats.find((seat) => seat.pax === getPaxName(passenger));
    },
    [selectedSeatSegments]
  );

  return selectedSeatSegments.length > 0 ? (
    <div>
      {passengers?.map((passenger, i) => (
        <SelectedSeat
          key={"seat-segment-" + i}
          pax={getPaxName(passenger)}
          seat={getSeatSegment(passenger, originCode, destinationCode)}
        />
      ))}
    </div>
  ) : null;
};
